import API from 'services/api';

export const confirmAnonymousRenter = (token: string): Promise<Record<string, never>> =>
  API.patch(`/api/users/anonymous-renter-confirm/${token}`).then(response => response?.data);
